export type Period = 'thisWeek' | 'thisMonth' | 'lastMonth' | 'thisYear' | `year_${number}`;

const YEARS_TO_SHOW = 3;

export const generatePeriodOptions = (): { label: string; value: Period }[] => {
  const currentYear = new Date().getFullYear();
  const baseOptions: { label: string; value: Period }[] = [
    { label: 'This Week', value: 'thisWeek' },
    { label: 'This Month', value: 'thisMonth' },
    { label: 'Last Month', value: 'lastMonth' },
    { label: 'This Year', value: 'thisYear' },
  ];

  const yearOptions: { label: string; value: Period }[] = [];
  for (let i = 1; i <= YEARS_TO_SHOW; i++) {
    const year = currentYear - i;
    if (year >= 2025) {
      yearOptions.push({ label: year.toString(), value: `year_${year}` as Period });
    }
  }

  return [...baseOptions, ...yearOptions];
};

export const periodToDateRange = (p: Period): { startDate: string; endDate: string } => {
  const now = new Date();
  const fmt = (d: Date) => d.toISOString().split('T')[0];

  if (p.startsWith('year_')) {
    const year = parseInt(p.replace('year_', ''));
    return { startDate: `${year}-01-01`, endDate: `${year}-12-31` };
  }
  switch (p) {
    case 'thisWeek': {
      const day = now.getDay();
      const diff = now.getDate() - day + (day === 0 ? -6 : 1);
      const monday = new Date(now.getFullYear(), now.getMonth(), diff);
      return { startDate: fmt(monday), endDate: fmt(now) };
    }
    case 'thisMonth':
      return {
        startDate: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`,
        endDate: fmt(now),
      };
    case 'lastMonth': {
      const lm = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const lmEnd = new Date(now.getFullYear(), now.getMonth(), 0);
      return { startDate: fmt(lm), endDate: fmt(lmEnd) };
    }
    case 'thisYear':
      return { startDate: `${now.getFullYear()}-01-01`, endDate: fmt(now) };
    default:
      return {
        startDate: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`,
        endDate: fmt(now),
      };
  }
};

export const periodToGroupBy = (p: Period): 'day' | 'month' => {
  if (p === 'thisYear' || p.startsWith('year_')) return 'month';
  return 'day';
};
